import { render } from "./MaskDetail.vue?vue&type=template&id=029555cf&scoped=true"
import script from "./MaskDetail.vue?vue&type=script&lang=js"
export * from "./MaskDetail.vue?vue&type=script&lang=js"

import "./MaskDetail.vue?vue&type=style&index=0&id=029555cf&scoped=true&lang=css"

import exportComponent from "../../node_modules/.pnpm/vue-loader@17.4.2_@vue+compiler-sfc@3.5.26_vue@3.5.26_webpack@5.104.1/node_modules/vue-loader/dist/exportHelper.js"
const __exports__ = /*#__PURE__*/exportComponent(script, [['render',render],['__scopeId',"data-v-029555cf"]])

export default __exports__